let lastAddTickerFunction = null;

// Configuration object with arrays for different platforms
const tickerNewsVisualizations = {
    addTickerNewsToLeftPanel: { // Only these positions have been verified
        VR: ["ticker-news", "-1.8 -2.9 0.0.1", ".9 .9 .9"],
        desktop: ["ticker-news", "0.7 -0.3 0.4", "1 1 1"],
        desktopVR: ["ticker-news", "0.7 -0.35 0.35", "1 1 1"]
    },
    addTickerNewsToCenterPanel: { // These have not
        VR: ["ticker-news", "0.1 -0.4 0.3", "0.15 0.15 0.15"],
        desktop: ["ticker-news", "0.2 -0.3 0.4", "0.2 0.2 0.2"],
        desktopVR: ["ticker-news", "0.15 -0.35 0.35", "0.18 0.18 0.18"]
    },
    addTickerNewsToRightPanel: { // These have not
        VR: ["ticker-news", "-0.1 -0.4 0.3", "0.15 0.15 0.15"],
        desktop: ["ticker-news", "-0.2 -0.3 0.4", "0.2 0.2 0.2"],
        desktopVR: ["ticker-news", "-0.15 -0.35 0.35", "0.18 0.18 0.18"]
    }
};

function createTickerNewsVisualizer(component, position, scale, panelId, contentId, ticker = 'NYSE') {
    const panel = document.getElementById(panelId);
    if (!panel) {
        if (__LOG_ERROR__) AppLog.error(`${panelId} not found`);
        return;
    }

    if (__LOG_INFO__) AppLog.info('[TickerNewsPlacements] createTickerNewsVisualizer start', { panelId, contentId, ticker, position, scale });

    let tickerNews = document.getElementById("ticker-news");
    const visualizerConfig = {
        ticker,
        position: position.split(' ').map(Number) // Convert string to vec3 array for component
    };

    if (!tickerNews) {
        const tickerVisualizer = document.createElement("a-entity");
        tickerVisualizer.setAttribute("id", "ticker-news");
        tickerVisualizer.setAttribute("ticker-news", visualizerConfig);
        tickerVisualizer.setAttribute("position", position);
        tickerVisualizer.setAttribute("scale", scale);

        const panelContent = document.getElementById(contentId);
        (panelContent || panel).appendChild(tickerVisualizer);
        if (__LOG_INFO__) AppLog.info('[TickerNewsPlacements] created ticker-news entity', { parentId: (panelContent || panel).id });
    } else {
        tickerNews.setAttribute("ticker-news", visualizerConfig);
        tickerNews.setAttribute("position", position);
        tickerNews.setAttribute("scale", scale);
        const parentId = tickerNews.parentElement ? tickerNews.parentElement.id : null;
        if (__LOG_INFO__) AppLog.info('[TickerNewsPlacements] updated existing ticker-news entity', { parentId });
    }
}

// Function to determine the current platform based on AppState
function getCurrentPlatform() {
    if (window.AppState.isTrueVRMode) return "VR";
    if (window.AppState.isPseudoVRMode) return "desktopVR";
    if (window.AppState.isDesktopMode) return "desktop";
    return "desktop"; // Fallback to desktop if no state is detected
}

// Platform-specific visualization functions with tracking
function addTickerNewsToLeftPanel(ticker = 'BUSINESS') {
    const platform = getCurrentPlatform();
    createTickerNewsVisualizer(
        ...tickerNewsVisualizations.addTickerNewsToLeftPanel[platform],
        "large-left-panel",
        "large-left-panel-content",
        ticker
    );
    lastAddTickerFunction = () => addTickerNewsToLeftPanel(ticker);
}

function addTickerNewsToCenterPanel(ticker = 'BUSINESS') {
    const platform = getCurrentPlatform();
    createTickerNewsVisualizer(
        ...tickerNewsVisualizations.addTickerNewsToCenterPanel[platform],
        "large-center-panel",
        "large-center-panel-content",
        ticker
    );
    lastAddTickerFunction = () => addTickerNewsToCenterPanel(ticker);
}

function addTickerNewsToRightPanel(ticker = 'BUSINESS') {
    const platform = getCurrentPlatform();
    createTickerNewsVisualizer(
        ...tickerNewsVisualizations.addTickerNewsToRightPanel[platform],
        "large-right-panel",
        "large-right-panel-content",
        ticker
    );
    lastAddTickerFunction = () => addTickerNewsToRightPanel(ticker);
}

// Startup function to initialize ticker news
function startupTickerNews(ticker = 'BUSINESS') {
    if (__LOG_INFO__) AppLog.info(`Starting ticker news with ticker: ${ticker}`);
    addTickerNewsToLeftPanel("BUSINESS");
}

// Export functions to window for global access (needed when bundled by webpack)
if (typeof window !== 'undefined') {
    window.createTickerNewsVisualizer = createTickerNewsVisualizer;
    window.getCurrentPlatform = getCurrentPlatform;
    window.addTickerNewsToLeftPanel = addTickerNewsToLeftPanel;
    window.addTickerNewsToCenterPanel = addTickerNewsToCenterPanel;
    window.addTickerNewsToRightPanel = addTickerNewsToRightPanel;
    window.startupTickerNews = startupTickerNews;
}

// Listen for app-state-changed event
document.addEventListener('DOMContentLoaded', () => {
    const scene = document.querySelector('a-scene');
    if (scene) {
        scene.addEventListener('app-state-changed', () => {
            if (lastAddTickerFunction) {
                if (__LOG_INFO__) AppLog.info('App state changed, re-running:', lastAddTickerFunction.name);
                lastAddTickerFunction();
            } else {
                if (__LOG_WARN__) AppLog.warn('No last addTicker function to re-run');
            }
        });
    } else {
        document.addEventListener('loaded', () => {
            const newScene = document.querySelector('a-scene');
            if (newScene) {
                newScene.addEventListener('app-state-changed', () => {
                    if (lastAddTickerFunction) {
                        if (__LOG_INFO__) AppLog.info('App state changed, re-running:', lastAddTickerFunction.name);
                        lastAddTickerFunction();
                    } else {
                        if (__LOG_WARN__) AppLog.warn('No last addTicker function to re-run');
                    }
                });
            }
        }, { once: true });
    }

});